import React from 'react';
import FamilyCardRo from './FamilyCardRo';

const body = [
  'Dr. Yuki Tanaka a dovedit că conștiința este un fenomen cuantic — descoperirea care a făcut posibilă procedura de upload. Familia ei a devenit <strong class="text-white">coloana vertebrală inginerească a civilizației solare</strong>: Reactorul Tanaka-Osei a obținut fuziunea susținută în 2087.',
  'Urmașii au gestionat Matricea Helios, au condus Recoltarea Atmosferică pe Jupiter și au crescut copii în coridoarele cu gravitație redusă ale Stației Valhalla. Tanaka-ii gândeau în sisteme. Ei nu întrebau <em>ce este posibil</em>, ci <em>ce rezistă</em>.',
  'Orașele subterane ale lui Mercur, flota de extracție He-3 a lui Jupiter, rețelele de ascultare a spațiului profund ale Stației Triton — infrastructura civilizației solare poartă, invizibil, scrisul lor.',
];

const FamilyTanakaRo = () => (
  <FamilyCardRo
    id="family-ro-1"
    accentColor="text-orange-400"
    dotColor="bg-orange-400"
    borderColor="border-orange-500/20"
    bgGlow="bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-orange-900/10 via-transparent to-transparent"
    tag="Inginerii · Mercur / Sistemul Interior"
    name="Familia Tanaka"
    origin="Mercur · Stația Valhalla · Sistemul Jupiter"
    body={body}
    quote="Fiica mea, astronomul. La vârsta ta, eu încercam să fac WiFi-ul să ajungă în dormitorul meu."
    quoteSource="Hiroshi Tanaka-Mwangi, Stația Valhalla, 2501"
  />
);

export default FamilyTanakaRo;